/** GTM registry: dataLayer event strings ({domain}_{action}) and DOM markers. Non-PII keys only. */

export const GTM_ANALYTICS_EVENT_CATEGORY = {
  userInteraction: 'User Interaction',
} as const;

/** Session-state markers set on `<body>` for GTM selectors. Tracking-only: never style these. */
export const GTM_BODY_CLASSES = {
  loginFromBackOffice: 'ga-login-from-backoffice',
} as const;

/** Login funnel (SP-32152) */
export const GTM_LOGIN_EVENTS = {
  loginSuccess: 'login_success',
  forgotPasswordClick: 'login_forgot_password_click',
  sendSignInCodeClick: 'login_send_sign_in_code_click',
  resendSignInCodeClick: 'login_resend_sign_in_code_click',
} as const;

/** Book confirmation */
export const GTM_CONFIRMATION_EVENTS = {
  downloadApplicationPdfClick: 'confirmation_download_application_pdf_click',
} as const;

/** Reports (WQS / industry view report dialog) */
export const GTM_REPORTS_EVENTS = {
  downloadApplicationPdfClick: 'reports_download_application_pdf_click',
  downloadOrderDocumentsClick: 'reports_download_order_documents_click',
} as const;

/** Renew / recertification / book from previous order */
export const GTM_RENEW_EVENTS = {
  bookRecertificationClick: 'renew_book_recertification_click',
  latestReportsRenewClick: 'renew_latest_reports_renew_click',
  previousOrderItemClick: 'renew_previous_order_item_click',
  reportsRenewClick: 'renew_reports_renew_click',
} as const;

/** UI language context (SP-37387) */
export const GTM_LANGUAGE_EVENTS = {
  contextUpdate: 'language_context_update',
} as const;
